var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\r\n      .right-arrow-1 {\r\n        fill: currentColor;\r\n      }\r\n    ")),React.createElement("g",{"id":"right-arrow","transform":"translate(440.784 32.727) rotate(-90)","key":1},React.createElement("g",{"id":"Group_19","data-name":"Group 19","transform":"translate(0 -440.784)"},React.createElement("path",{"id":"Path_13","data-name":"Path 13","className":"right-arrow-1","d":"M-488.967,0l-9.143,12.97L-507.282,0h-7.206l16.364,23.14h0L-481.76,0Z","transform":"translate(514.488)"})))]);
}

RightArrow.defaultProps = {"viewBox":"0 0 23.14 32.728"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
